import { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import Select from 'react-select';
import CurrencyInput from 'react-currency-input-field';

import { crearEmpleado } from '../../actions/empleados';
import { buscarSucursales } from '../../actions/sucursales';
import { editarBreadcrumb } from '../../actions/breadcrumb';
import { CustomValueContainer } from '../../components/react_select/ReactSelect';

const styles_select = {
    menuPortal: base => ({ ...base, zIndex: 9999 }),
    container: (provided, state) => ({
        ...provided,
    }),
    control: (provided, state) => ({
        ...provided,
        paddingTop: '5px',
        paddingBottom: '5px',
    }),
    valueContainer: (provided, state) => ({
        ...provided,
        overflow: "visible",
        marginTop: "10px"
    }),
    placeholder: (provided, state) => ({
        ...provided,
        position: "absolute",
        top: state.hasValue || state.selectProps.inputValue ? -15 : "0%",
        transition: "top 0.1s, font-size 0.1s",
        fontSize: (state.hasValue || state.selectProps.inputValue) && 13
    })
};

const opcionesBooleanas = [
    { value: true, label: 'Sí' },
    { value: false, label: 'No' }
];

const tiposEmpleado = [
    { value: 0, label: 'Cajero' },
    { value: 1, label: 'Bateador' },
    { value: 2, label: 'Promotor' }, 
    { value: 3, label: 'Freidor' }, 
    { value: 4, label: 'Vendedor ambulante' }, 
    { value: 5, label: 'Administrador' }
];

const NuevoEmpleado = () => {

    const dispatch = useDispatch();
    const navigate = useNavigate();

    const sucursalesListado = useSelector(state => state.sucursales.listado);

    const [empleadoData, setEmpleadoData] = useState({
        nombre: null,
        apellido_paterno: null,
        apellido_materno: null,
        sucursales: [],
        tipo: null,
        sueldo: null,
        telefono: null,
        usuario: null,
        password: null,
        cortesia: null,
        especial: null
    });

    const [sucursalData, setSucursalData] = useState([]);
    const [tipoData, setTipoData] = useState(null);
    const [cortesiaData, setCortesiaData] = useState(null);
    const [especialData, setEspecialData] = useState(null);

    const [statusProcesar, setStatusProcesar] = useState(false);

    useEffect(() => {
        dispatch(buscarSucursales());

        dispatch(editarBreadcrumb([
            { nombre: 'Empleados', path: '/empleados', activo: false },
            { nombre: 'Nuevo empleado', path: '/empleados/nuevo', activo: true }
        ]));
    }, []);

    const handleInputChange = ({ target }) => {
        setEmpleadoData({ ...empleadoData, [target.name]: target.value });
    };

    const handleNumberChange = (value, name) => {
        setEmpleadoData({ ...empleadoData, [name]: value || '' });
    };

    const handleSelectSucursal = (options) => {
        setSucursalData(options || []);
        setEmpleadoData({ ...empleadoData, sucursales: (options || []).map(o => o.value) });
    };

    const handleSelectTipo = (option) => {
        setTipoData(option);
        setEmpleadoData({ ...empleadoData, tipo: option?.value ?? null });
    };

    const handleSelectCortesia = (option) => {
        setCortesiaData(option);
        setEmpleadoData({ ...empleadoData, cortesia: option?.value ?? null });
    };

    const handleSelectEspecial = (option) => {
        setEspecialData(option);
        setEmpleadoData({ ...empleadoData, especial: option?.value ?? null });
    };

    const handleSubmit = async () => {
        setStatusProcesar(true);
        await dispatch(crearEmpleado(empleadoData));
        setStatusProcesar(false);
        navigate('/empleados');
    };

    const sucursalesOpciones = sucursalesListado.map(m => ({ value: m._id, label: m.nombre }));

    return (
        <div className="row mt-5">
            <div className="col-12 mb-3 d-flex justify-content-between align-items-center">
                <h4 className="mb-4">Nuevo empleado</h4>
            </div>

            <div className="col-12">
                <div className="accordion" id="accordionNuevoEmpleado">
                    <div className="accordion-item">
                        <h2 className="accordion-header" id="headingInfo">
                            <button className="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#collapseInfo" aria-expanded="true" aria-controls="collapseInfo">
                                Información del empleado
                            </button>
                        </h2>
                        <div id="collapseInfo" className="accordion-collapse collapse show" aria-labelledby="headingInfo" data-bs-parent="#accordionNuevoEmpleado">
                            <div className="accordion-body">
                                <div className="row">
                                    <div className="col-md-2 mb-3">
                                        <div className="form-floating">
                                            <input
                                                type="text"
                                                className="form-control"
                                                placeholder="Nombre"
                                                id="nombre"
                                                name="nombre"
                                                value={empleadoData.nombre || ''}
                                                onChange={handleInputChange}
                                            />
                                            <label htmlFor="nombre">Nombre</label>
                                        </div>
                                    </div>

                                    <div className="col-md-2 mb-3">
                                        <div className="form-floating">
                                            <input
                                                type="text"
                                                className="form-control"
                                                placeholder="Apellido paterno"
                                                id="apellido_paterno"
                                                name="apellido_paterno"
                                                value={empleadoData.apellido_paterno || ''}
                                                onChange={handleInputChange}
                                            />
                                            <label htmlFor="apellido_paterno">Apellido paterno</label>
                                        </div>
                                    </div>

                                    <div className="col-md-2 mb-3">
                                        <div className="form-floating">
                                            <input
                                                type="text"
                                                className="form-control"
                                                placeholder="Apellido materno"
                                                id="apellido_materno"
                                                name="apellido_materno"
                                                value={empleadoData.apellido_materno || ''}
                                                onChange={handleInputChange}
                                            />
                                            <label htmlFor="apellido_materno">Apellido materno</label>
                                        </div>
                                    </div>

                                    <div className="col-md-2 form-group mb-3">
                                        <div className="input-group h-100">
                                            <Select
                                                name="tipo"
                                                className="select-group"
                                                classNamePrefix="react-select"
                                                placeholder="Tipo de empleado"
                                                options={tiposEmpleado}
                                                value={tipoData}
                                                onChange={handleSelectTipo}
                                                menuPortalTarget={document.body}
                                                components={{ ValueContainer: CustomValueContainer }}
                                                styles={{ ...styles_select }}
                                                isClearable
                                            />
                                        </div>
                                    </div>

                                    <div className="col-md-2 mb-3">
                                        <div className="form-floating">
                                            <CurrencyInput
                                                className="form-control"
                                                placeholder="Sueldo diario"
                                                id="sueldo"
                                                name="sueldo"
                                                value={empleadoData.sueldo || ''}
                                                onValueChange={(value, name) => handleNumberChange(value, name)}
                                                prefix="$"
                                                decimalsLimit={2}
                                                groupSeparator=","
                                                decimalSeparator="."
                                            />
                                            <label htmlFor="sueldo">Sueldo diario</label>
                                        </div>
                                    </div>

                                    <div className="col-md-2 mb-3">
                                        <div className="form-floating">
                                            <input
                                                type="text"
                                                className="form-control"
                                                placeholder="Teléfono"
                                                id="telefono"
                                                name="telefono"
                                                value={empleadoData.telefono || ''}
                                                onChange={handleInputChange}
                                            />
                                            <label htmlFor="telefono">Teléfono</label>
                                        </div>
                                    </div>

                                    <div className="col-md-2 mb-3">
                                        <div className="form-floating">
                                            <input
                                                type="text"
                                                className="form-control"
                                                placeholder="Usuario"
                                                id="usuario"
                                                name="usuario"
                                                value={empleadoData.usuario || ''}
                                                onChange={handleInputChange}
                                            />
                                            <label htmlFor="usuario">Usuario</label>
                                        </div>
                                    </div>

                                    <div className="col-md-2 mb-3">
                                        <div className="form-floating">
                                            <input
                                                type="text"
                                                className="form-control"
                                                placeholder="Contraseña"
                                                id="password"
                                                name="password"
                                                value={empleadoData.password || ''}
                                                onChange={handleInputChange}
                                            />
                                            <label htmlFor="password">Contraseña</label>
                                        </div>
                                    </div>

                                    <div className="col-md-2 form-group mb-3">
                                        <div className="input-group h-100">
                                            <Select
                                                className="select-group"
                                                classNamePrefix="react-select"
                                                placeholder="Cortesía (100%)"
                                                options={opcionesBooleanas}
                                                value={cortesiaData}
                                                onChange={handleSelectCortesia}
                                                menuPortalTarget={document.body}
                                                components={{ ValueContainer: CustomValueContainer }}
                                                styles={{ ...styles_select }}
                                                isClearable
                                            />
                                        </div>
                                    </div>

                                    <div className="col-md-2 form-group mb-3">
                                        <div className="input-group h-100">
                                            <Select
                                                className="select-group"
                                                classNamePrefix="react-select"
                                                placeholder="Precio especial (50%)"
                                                options={opcionesBooleanas}
                                                value={especialData}
                                                onChange={handleSelectEspecial}
                                                menuPortalTarget={document.body}
                                                components={{ ValueContainer: CustomValueContainer }}
                                                styles={{ ...styles_select }}
                                                isClearable
                                            />
                                        </div>
                                    </div>

                                    <div className="col-md-4 form-group mb-3">
                                        <div className="input-group h-100">
                                            <Select
                                                name="sucursales"
                                                className="select-group"
                                                classNamePrefix="react-select"
                                                placeholder="Sucursales asignadas"
                                                options={sucursalesOpciones}
                                                value={sucursalData}
                                                onChange={handleSelectSucursal}
                                                menuPortalTarget={document.body}
                                                components={{ ValueContainer: CustomValueContainer }}
                                                styles={{ ...styles_select }}
                                                isMulti
                                                isClearable
                                            />
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="col-12 mt-3 d-flex justify-content-end">
                <button className="btn btn-secondary me-2" onClick={() => navigate('/empleados')} disabled={statusProcesar}>
                    Cancelar
                </button>
                {
                    statusProcesar
                        ? <button className="btn btn-success" disabled><span className="spinner-border spinner-border-sm me-1" role="status" aria-hidden="true"></span> Guardando</button>
                        : <button className="btn btn-success" onClick={handleSubmit}><i className="fas fa-check me-1"></i> Guardar</button>
                }
            </div>
        </div>
    );
};

export default NuevoEmpleado;
